interface NamedPerson {
  first_name?: string | null;
  last_name?: string | null;
  display_name?: string | null;
  email?: string | null;
}

export function formatReportPersonName(person: NamedPerson | null | undefined): string {
  if (!person) return '';
  const displayName = person.display_name?.trim();
  if (displayName) return displayName;
  const fullName = `${person.first_name ?? ''} ${person.last_name ?? ''}`.trim();
  return fullName || person.email?.trim() || '';
}
